import { render, staticRenderFns } from "./LeadList.vue?vue&type=template&id=6bf05583&scoped=true"
import script from "./LeadList.vue?vue&type=script&lang=js"
export * from "./LeadList.vue?vue&type=script&lang=js"
import style0 from "./LeadList.vue?vue&type=style&index=0&id=6bf05583&prod&scoped=true&lang=css"
import style1 from "./LeadList.vue?vue&type=style&index=1&id=6bf05583&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf05583",
  null
  
)

export default component.exports